import React from 'react'
import './Offersec.css'
import icncheck from '../../assets/icons/check-circle.svg'
import img from '../../assets/others/11102037.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom';
library.add(fas)


const Offersec = () => {
  return (
    <div class="offer-section ws-section bg-2 dark-bg ps-4 pe-3">
            
                <div class="row dark-bg justify-content-end">
                
                    <div class="col-lg-6 pb-3">
                    <div class="container">
                        <div class="ws-section_heading mb-4">Join the Future of Electronics: Comprehensive VLSI Training Programs</div>
                        
                        
                     <div class="row mb-5 g-3">
                    <div class="col-lg-6 mb-lg-3">
                       <div className='icon-left-bx d-flex'>
                        <div className='icn-img'> <img src={icncheck} alt=''/>
                        </div>
                        <div className='icn-heading'>Job-oriented VLSI courses</div>
                       </div>
                    </div>
                    <div class="col-lg-6">
                       <div className='icon-left-bx d-flex'>
                        <div className='icn-img'> <img src={icncheck} alt=''/>
                        </div>
                        <div className='icn-heading'>Online VLSI courses</div>
                       </div>
                    </div>
                    <div class="col-lg-6">
                       <div className='icon-left-bx d-flex'>
                        <div className='icn-img'> <img src={icncheck} alt=''/>
                        </div>
                        <div className='icn-heading'>Part-time VLSI courses</div>
                       </div>
                    </div>
                    <div class="col-lg-6">
                       <div className='icon-left-bx d-flex'>
                        <div className='icn-img'> <img src={icncheck} alt=''/>
                        </div>
                        <div className='icn-heading'>VLSI Internship</div>
                       </div>
                    </div>
                     </div>
                     <div class="row pt-3 pb-4">
                            
                            <div class="col-lg align-self-center">
                            <a class="btn-primary btn-icon btn-white" href="/register-now/">Enroll Now<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></a>

                            </div>
                        </div>
                      
                     </div>
                    </div>
              
                <div class="col-lg-5 mt--14 d-none d-sm-block">
                    <img src={img} alt=''/>
                    </div>
                    </div>
            </div>
      
  )
}

export default Offersec